import * as React from 'react';

import styled from 'styled-components';

import Grid from '@components/basics/grid';
import MotionOpacity from '@components/motion/motion-opacity';

import DEFAULT_IMG from '@webapp/pages/merch/test.png';

import MerchProductColor from '../merch-color';

export type MerchColorOptions = {
  id: number;
  label: string;
  selected?: boolean;
  color?: string;
  productImgSrc?: string;
}[];

interface MerchColorListProps {
  className?: string;
  variants: MerchColorOptions;
  productId?: number;
  onChange: (data: MerchColorOptions) => void;
}

export const MerchColorList: React.FC<MerchColorListProps> = ({
  className,
  variants,
  productId,
  onChange,
}) => {
  return (
    <MotionOpacity>
      <ProductListWrapper className={className} productLength={variants.length}>
        {variants.map((product, i) => (
          <MerchProductColor
            key={`product-${i}`}
            className="product"
            productImgSrc={variants[0].productImgSrc || DEFAULT_IMG}
            productColor={product.label}
            selected={product.selected}
            productId={productId}
            colorCode={product.color || 'white'}
            small
            filtered
            onClick={() =>
              onChange(
                variants.map((p) => {
                  return {
                    ...p,
                    selected: p.id === product.id,
                  };
                })
              )
            }
          />
        ))}
      </ProductListWrapper>
    </MotionOpacity>
  );
};

export default MerchColorList;

const ProductListWrapper = styled(Grid)<{ productLength?: number }>`
  align-items: flex-start;
  justify-content: flex-start;
  flex-wrap: wrap;
  grid-gap: 3px;
  grid-row-gap: 5px;
  grid-template-columns: repeat(2, minmax(0, 1fr));

  @media ${({ theme }) => theme.device.tablet} {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }

  .product {
    flex-grow: 1;
    width: 100%;
  }
`;
